import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone';
import LoadingSmall from "../../components/LoadingSmall";
import axios from 'axios';
import Portal from "react-portal";
import FullScreenOverlay from "../../components/FullScreenOverlay";
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import TextField from '../../components/ReduxForm/text';
import Dropdown from "../../components/ReduxForm/dropdown";
import NUmberPicker from "../../components/ReduxForm/numberpicker";
import Template from "./template";
import Notification from '../../components/Notification';
import Rule from './Rule';
import Type from './Type';
import WidgetType from './WidgetType';
import GeneralHelper from "../../modules/General";
import Loading from "../../components/Loading";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import UpgradeRequired from "../../components/UpgradeRequired";
import CodeMirror from 'react-codemirror';
import RecommendationHelper from "./RecommendationHelper";

const validate = values => {
    const errors = {}

    if(!values.description) {
        errors.description = 'Required';
    }

    if(values.description) {
        if(values.description.match(/[^A-Za-z0-9\-_@]/)) {
            errors.description = 'Only A-Z,@ and 0-9';
        }
    }

    if(!values.template_id) {
        errors.template_id = 'Required';
    }



    return errors
}

class NewRecommendationForm extends React.Component {
    constructor(props) {
        super(props);

        this.codeMirrorOptions = {
            lineNumbers: true,
            mode:'text/html',
            indentWithTabs:true,
            styleSelectedText: true,
            tabSize:5,
            indentUnit:5,
        };

        this.initialRules = {
            HasAttributes: {
                key:'has_attributes',
                operator:'=',
                value:1,
                type:'and',
            },
            Price: {
                key:'price',
                operator:'=',
                value:100,
                type:'and',
            },
            OnSale: {
                key:'on_sale',
                operator:'=',
                value:1,
                type:'and',
            },
            Quantity: {
                key:'quantity',
                operator:'>=',
                value:1,
                type:'and',
            },
            Category: {
                key:'category',
                operator:'=',
                value:false,
                type:'and',
            },
            Brand: {
                key:'brand',
                operator:'=',
                value:false,
                type:'and',
            }
        };



        this.state = {
            codeFor:'',
            provider:'',
            isSaving:false,
            isLoading:false,
            templates:[],
            showTestDialog:false,
            selectedRule:'0',
            recommendation:{
                id:false,
                type:'shop',
                fallback:'',
                algorithm:'BestsellersInStore',
            },
            rules:[
                this.initialRules.Quantity
            ],
            showAdvancedRules:false,
            showDialog:false,
        }

        this.algorithms = [
            {
                key:'BestsellersInStore',
                title:'Bestsellers in store',
                description:'Showcase your bestselling products',
                type:'recommendation',
                usable:'all',
            },
            {
                key:'GlobalVisitedProducts',
                title:'Last product views in store by all customers',
                description:'Show all products that are viewed by customers right now',
                type:'recommendation',
                usable:'all'
            },
            {
                key:'VisitedProducts',
                title:'Last visited products',
                description:'Show the last products the visitor has viewed',
                type:'recommendation',
                usable:'all'
            },
            {
                key:'Newest',
                title:'Newest products',
                description:'Showcase your newest products',
                type:'recommendation',
                usable:'all'
            },
            {
                key:'RelevantProduct',
                title:'Relevant products for a specific product',
                description:'Products that goes along with a specific product',
                type:'recommendation',
                usable:'shop'
            },
            {
                key:'Trending',
                title:'Trending products',
                description:'Products that had a sudden increase in number of purchases',
                type:'recommendation',
                usable:'all'
            },
            {
                key:'RelevantBrowsingtIntrest',
                title:'Recommend by browsing history',
                description:'Recommend products based on visitor browsing history',
                type:'recommendation',
                usable:'all'
            },
            {
                key:'RelevantProductCart',
                title:'Relevant products based on items in cart',
                description:'Products that goes along with cart items',
                type:'recommendation',
                usable:'shop'
            },
            {
                key:'AlternativeProduct',
                title:'Alternative products',
                description:'Products that are similar to a product',
                type:'recommendation',
                usable:'shop'
            },
            {
                key:'RelevantOrderRecommendation',
                title:'Order recommendation',
                description:'Recommend products based on latest order',
                type:'recommendation',
                usable:'all'
            },
            {
                usable:'shop',
                key:'Search',
                title:'Search',
                type:'search',
                description:'Search for products matching a query. The search result will be weighted based on relevancy, brands, bestsellers and so on.',
            }

        ]

        this.handleNewTemplate = this.handleNewTemplate.bind(this);
        this.changeRuleDropdown = this.changeRuleDropdown.bind(this);
        this.addRule = this.addRule.bind(this);
        this.handleRuleChange = this.handleRuleChange.bind(this);
        this.deleteRule = this.deleteRule.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.switchAlgorithm = this.switchAlgorithm.bind(this);
        this.showCode = this.showCode.bind(this);
        this.copyCode = this.copyCode.bind(this);
    }

    copyCode() {
        Notification.success('Code saved to clipboard');
    }



    getCurrentAlgorithm() {
        let algorithm = false;

        this.algorithms.map(algo => {
            if(algo.key == this.state.recommendation.algorithm) {
                algorithm = algo;
            }
        })

        return algorithm;
    }

    getTestImages = () => {
        let code = '<center>';
        let t = Math.floor(Date.now() / 1000);

        for(let i = 0; i<this.props.number_of_products;i++) {
            code += `<img src="https://app.crall.io/beacon/v2/recommendation/${this.state.recommendation.account_id}/${this.state.recommendation.description}/embed?i=${i}&timestamp=${t}" />`;
        }

        code += '</center>';

        return code;
    }


    showCode() {
        let code = `<div class="crall-recommendation-box" data-recommendation-id="${this.state.recommendation.description}"></div>`;

        if(this.getCurrentAlgorithm().type == 'search') {
            code = `<div class="crall-search" data-search-container="[CSS_SELECTOR_FOR_SEARCH_INPUT]" data-recommendation-id="${this.state.recommendation.description}"></div>`;
        }

        if(this.state.recommendation.type == 'email' && this.state.provider != '') {
            code = RecommendationHelper.emailCode(this.state.recommendation,this.state.provider);
        }

        return (
            <div className="col-sm-12">
                {
                    this.state.recommendation.type == 'email' ?
                        <div className="col-sm-6">
                            <select className="form-control" value={this.state.provider} onChange={(e) => this.setState({provider:e.target.value})}>
                                <option value="0">Select e-mail provider</option>
                                <option value="custom">Custom</option>
                                <option value="apsis">Apsis</option>
                                <option value="mailchimp">Mailchimp</option>
                                <option value="crall">Crall</option>
                            </select>
                        </div>:null
                }

                {
                    this.state.recommendation.type == 'shop' || (this.state.recommendation.type != '' && this.state.provider != '') ?
                        <div className="col-sm-12">
                            <table style={{width:'100%',marginTop:'15px',tableLayout:'fixed'}}>
                                <tbody>
                                <tr>
                                    <td style={{width:'80%'}} ref="code">

                                        <CodeMirror value={code} options={this.codeMirrorOptions} />
                                    </td>
                                    <td style={{textAlign:'right',width:'20%'}}>
                                        <CopyToClipboard
                                            onCopy={this.copyCode}
                                            options={{message: 'Whoa!'}}
                                            text={code}>
                                            <button type="button" onClick={this.copyCode} className="btn btn-primary btn-outline">Copy to clipboard</button>
                                        </CopyToClipboard>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>:null
                }
            </div>
        );
    }

    switchAlgorithm(algo) {
        this.props.change('algorithm',algo);

        this.setState({
            recommendation:{
                ...this.state.recommendation,
                algorithm:algo,
            }
        })
    }

    deleteRule(index) {
        let rules = this.state.rules.filter((rule,i) => {
            if(i == index) {
                return false
            }

            return true;
        });

        this.setState({
            rules:rules
        });
    }

    handleRuleChange(index,key,value) {

        let rules = this.state.rules.map((rule,i) => {
            if(i == index) {
                return Object.assign({}, rule, {[key]:value})
            }

            return rule;
        });

        this.setState({
            rules:rules
        });
    }

    handleFallbackChange = (e) => {
        let value = e.target.checked;

        if(value == false) {
            value = 1;
        }else{
            value = '';
        }

        this.setState({
            recommendation:{
                ...this.state.recommendation,
                fallback:value
            }
        })
    }

    getFallbackValue = () => {
        return this.state.recommendation.fallback == '' ? true:false;
    }


    changeRuleDropdown(e) {
        this.setState({selectedRule:e.target.value});
    }

    addRule() {

        if(this.state.selectedRule == '0') {
            Notification.error('You must select a rule to add');
            return;
        }

        this.setState({
            rules:[
                ...this.state.rules,
                this.initialRules[this.state.selectedRule]
            ],
            selectedRule:'0'
        });

    }

    handleNewTemplate(template) {
        this.setState({
            templates:[
                ...this.state.templates,
                template,
            ]
        })

        this.props.change('template_id',template.id);
    }

    componentWillMount() {
        axios.get('/recommendations/templates').then(res => {
            this.setState({
                templates:res.data
            })
        });

        if(this.props.recommendationId) {
            this.setState({
                isLoading:true
            })

            axios.get('/recommendations/'+this.props.recommendationId).then(res => {
                let rules = res.data.rules;
                delete res.data.rules;

                rules = rules.map((rule) => {
                    if(rule.type == '' || !rule.type) {
                        rule.type = 'and';
                    }
                    return rule;
                });

                if(res.data.type == '' || !res.data.type) {
                    res.data.type = 'shop';
                }

                if(res.data.fallback == '' || !res.data.fallback) {
                    res.data.fallback = '';
                }


                this.props.change('description',res.data.description);
                this.props.change('algorithm',res.data.algorithm);
                this.props.change('template_id',res.data.template_id);
                this.props.change('number_of_products',res.data.number_of_products);
                this.props.change('visible',res.data.visible);

                this.setState({
                    recommendation:res.data,
                    rules:rules,
                    isLoading:false
                })
            });
        }
    }

    changeRecommendationType = (type) => {
        this.setState({
            recommendation:{
                ...this.state.recommendation,
                type:type,
            }
        })
    }

    onSubmit(data){
        data = Object.assign({},this.state.recommendation,data);
        data.rules = this.state.rules;
        this.setState({
            isSaving:true
        });

        let method = 'post';
        let url = '/recommendations';

        if(this.props.recommendationId) {
            method = 'put';
            url += '/'+this.props.recommendationId;
        }

        axios[method](url,data)
            .then((response) => {
                Notification.success('Recommendation saved');
                this.setState({
                    isSaving:false,
                    recommendation:response.data
                })

                this.props.onSubmit(response.data.id);
            })
            .catch((error) => {
                Notification.error(error.message);
            });
    }

    testRules = () => {
        this.setState({
            showTestDialog:true,
        });
    }

    renderSaveButton = () => {
        if(!this.props.enabled) {
            return <UpgradeRequired message="If you want to use recommendations, you'll need to subscribe to the 'Recommendation'-feature." />
        }

        if(this.getCurrentAlgorithm().type == 'search' && this.props.hasSearch != '1') {
            return <UpgradeRequired message="If you want to use personalized search, you need to subscribe to the 'Search'-feature." />
        }

        if(this.getCurrentAlgorithm().type == 'recommendation' && this.props.hasRecommendation != '1') {
            return <UpgradeRequired message="If you want to use recommendations, you need to subscribe to the 'Recommendation'-feature." />
        }


        return <button type="submit" className="btn btn-success btn-icon btn-block"><i className="icon fa-floppy-o"></i> Save recommendation</button>

    }


    render() {
        const { handleSubmit } = this.props;

        if(this.state.isLoading) {
            return (
                <Loading error={false} />
            );
        }

        return (
            <div>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                <OptionColumn title="1. Recommendation ID" description="Give this recommendation a unique ID. You'll use this value when you're embedding our recommendations.">
                    <Field component={TextField} name="description" placeholder="MyAwesomeRecommendation" />
                    <span>Recommendation ID can only contain a-z and 0-9</span>
                </OptionColumn>

                <SplitRows />

                <OptionColumn title="2. Type" description="Where do you want to impletement the widget">
                    <WidgetType
                        key="shop"
                        value={this.state.recommendation.type}
                        handleClick={this.changeRecommendationType}
                        type="shop"
                        title="Shop"
                        description="I want to display this widget in my shop."
                    />

                    <WidgetType
                        key="email"
                        value={this.state.recommendation.type}
                        handleClick={this.changeRecommendationType}
                        type="email"
                        title="E-mails"
                        description="I want to use this widget in my emails"
                    />
                </OptionColumn>

                <SplitRows />
                    <OptionColumn title="3. Product selection" description="Recommendation type">
                        {
                            this.algorithms.map(algo => {
                                if(this.state.recommendation.type == algo.usable || algo.usable == 'all') {
                                    return <Type
                                        key={algo.key}
                                        value={this.state.recommendation.algorithm}
                                        handleClick={this.switchAlgorithm}
                                        algorithm={algo.key}
                                        title={algo.title}
                                        description={algo.description}
                                    />
                                }
                            })
                        }

                    </OptionColumn>
                <SplitRows />

                <OptionColumn title="4. Product filtering" description="Select additional rules">
                    <div className="col-sm-5">
                        <Field component={NUmberPicker} min={1} max={24} affix="products" title="How many products should presented to the visitor:" name="number_of_products" />

                    </div>
                    <div className="col-sm-5">
                        {
                            this.getCurrentAlgorithm().type == 'search' ? null:<Field component={NUmberPicker} min={1} max={10} affix="products" title="Number of products that should be displayed at once:" name="visible" />
                        }

                    </div>

                    <div className="col-sm-2">
                        <div className={`form-group`}>
                            <label className="form-control-label">&nbsp;</label><br />
                            <button type="button" className="btn btn-dark" onClick={() => { this.setState({showAdvancedRules:!this.state.showAdvancedRules}); }}><i className="icon wb-more-vertical"></i>Advanced</button>
                        </div>
                    </div>

                    {
                        this.state.showAdvancedRules ?
                            <div className="col-sm-12 ">
                                <SplitRows />

                                <div className="col-sm-12 p-0">
                                    <div className="col-sm-12 p-0">
                                        <div className="col-sm-8 p-0">
                                            <select className="form-control" value={this.state.selectedRule} onChange={this.changeRuleDropdown}>
                                                <option value="0">Select a rule</option>
                                                <option value="HasAttributes">Has attributes</option>
                                                <option value="Price">Price</option>
                                                <option value="OnSale">Is on sale</option>
                                                <option value="Quantity">Quantity</option>
                                                <option value="Category">Category</option>
                                                <option value="Brand">Brand</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-2">
                                            <button type="button" className="btn btn-dark" onClick={this.addRule}><i className="icon wb-plus"></i></button>
                                        </div>
                                        <div className="col-sm-2">
                                            <button type="button" className="btn btn-dark" onClick={this.testRules}>Test rules</button>
                                        </div>
                                        <SplitRows />
                                    </div>
                                    <div className="col-sm-12 p-0">
                                        <table className="table">
                                            <tbody>
                                                {
                                                    this.state.rules.map((rule,i) => {
                                                        return <Rule delete={this.deleteRule} handleRuleChange={this.handleRuleChange} key={i} rule={rule} index={i} />
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <SplitRows />
                                    <div className="col-sm-12 p-0">
                                        <div className="checkbox-custom checkbox-primary">
                                            <input type="checkbox" checked={this.getFallbackValue()} onChange={this.handleFallbackChange} />
                                            <label>Fill with random products if the widget are missing products</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :null
                    }

                </OptionColumn>

                <SplitRows />

                <OptionColumn title="5. Template" description="Pick a template to render">
                    <div className="col-sm-10">
                        <Field component={Dropdown} placeholder="Select template" name="template_id"
                               options={this.state.templates.map(template => {
                                   return {
                                       label:`#${template.id} - ${template.description}`,
                                       value:template.id
                                   }
                               })} />
                    </div>
                    <div className="col-sm-2">
                        <button type="button" className="btn btn-dark" onClick={() => { this.setState({showDialog:true}); }}><i className="icon fa-plus"></i> New template</button>
                    </div>
                </OptionColumn>

                <SplitRows />


                <OptionColumn title="6. Code" description="Save recommendation and get your implementation code">
                    <div className="alert alert-primary" role="alert" style={{display:'inline-block',width:'100%'}}>
                        {
                            this.state.recommendation.id ?
                                this.showCode()
                            :
                                "You must save this recommendation before your can get your code."
                        }
                    </div>

                    {
                        this.state.isSaving ? <LoadingSmall />:
                            this.renderSaveButton()

                    }
                </OptionColumn>

                <SplitRows />


            </form>
                <Portal closeOnEsc onClose={e => {this.setState({showDialog:false})}} isOpened={this.state.showDialog}>
                    <FullScreenOverlay>
                        <Template handleSave={this.handleNewTemplate} enabled={true} onClose={e => {this.setState({showDialog:false})}} recommendationId={false} />
                    </FullScreenOverlay>
                </Portal>

                <Portal closeOnEsc onClose={e => {this.setState({showTestDialog:false})}} isOpened={this.state.showTestDialog}>
                    <FullScreenOverlay>
                        <div className="col-sm-12 text-center">
                            <h1>Preview</h1>
                            <h2>The products will appear below. It may take a couple of seconds before it loads</h2>
                            <hr />
                            <div style={{width:'600px',marginLeft:'auto',marginRight:'auto'}} dangerouslySetInnerHTML={{__html: this.getTestImages()}} />
                        </div>
                    </FullScreenOverlay>
                </Portal>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});

const selector = formValueSelector('NewRecommendationForm');

// Decorate the form component
NewRecommendationForm = reduxForm({
    form: 'NewRecommendationForm',
    validate,
})(NewRecommendationForm);

NewRecommendationForm = connect(
    state => ({
        number_of_products:selector(state, 'number_of_products'),
        initialValues: {
            number_of_products:12,
            visible:4,
            algorithm:'BestsellersInStore'
        }
    })
)(NewRecommendationForm)

export default NewRecommendationForm;



// WEBPACK FOOTER //
// ./containers/recommendations/NewRecommendationForm.js